const messages = {
  title: "Trgovina",
  description: "Dobrodošli u shop nagrada. Ovdje možete unovčiti vaše Bridgestone Plus bodove <br/> za nagrade iz različitih kategorija. Ponuda proizvoda <br/> se redovno ažurira. Uživajte u pregledanju.",
  sort: {
    asc: "Sortiraj po: Najniža cijena",
    desc: "Sortiraj po: Najviša cijena",
  },
  productSearchBox: {
    from: "bodovi od",
    to: "bodovi do",
  },
  noProducts: "Kriteriji pretrage nisu dali rezultata",
  quantity: "Količina",
  search: "Pretraži",
  perPage: "Stavki po stranici",
  timeUnavailable: "Trenutno nije dostupno u ovom trenutku",
  product: "Proizvod",
  cart: {
    pointsPerUnit: "Bodovi po jedinici",
    pointsSum: "Zbroj bodova",
  },
  action: "Akcija",
  pointsTotal: "Ukupno",
  cartRemainPoints: "Preostali bodovi u košarici",
  shoppingCart: "Košarica",
  emptyCart: "Košarica je prazna.",
  attributes: "Atributi",
  selectAddressP: "Molimo odaberite vašu adresu za dostavu",
  orderDelivery: "Adresa za dostavu",
  selectedProducts: "Odabrani proizvodi",
  orderSummary: "Pregled narudžbe",
  contactPerson: "Kontakt osoba",
  selectedAddress: "Odabrana adresa",
  order: {
    success: "Hvala vam! Vaša narudžba je uspješna. Primit ćete potvrdu narudžbe u vašoj primljenoj pošti za nekoliko minuta.",
    description: "Ovdje ćete pronaći pregled vaših narudžbi iz shopa nagrada.",
    info: "Ovdje ćete pronaći pregled vaših narudžbi iz shopa nagrada.",
    date: "Datum narudžbe",
    number: "Br. narudžbe",
    status: {
      created: "Kreirano",
      confirm_order: "Potvrdi narudžbu",
      ready_for_shipment: "Spremno za slanje",
      rejected: "Odbijeno",
      processed: "Obrađeno",
      shipped: "Poslano",
      returned: "Vraćeno",
      finished: "Završeno",
    },
    anyOrder: "Nema narudžbi",
    products: "Proizvodi",
    quantity_short: "kom",
    itemRemoved: "nije moguće isporučiti",
  },
  orders: "Narudžbe",
  notEnoughPoints: "Nema dovoljno dostupnih bodova.",
  statusText: "Status",
  outOfStock: "Trenutno nije na stanju",
  productUnavailable: "Ovaj proizvod više nije dostupan.",
  deletedProductsTitle: "Proizvodi više nisu dostupni",
  deletedProductsMessage: "Sljedeći proizvodi više nisu dostupni. Uklonite ih iz košarice kako biste nastavili.",
  removeSelected: "Ukloni odabrano",
  clearCart: "Isprazni košaricu",
  removeSelectedConfirm: "Ukloniti odabrane proizvode iz košarice?",
  clearCartConfirm: "Ukloniti sve proizvode iz košarice?",
  incompleteAddress: {
    firstName: "Dodajte ime u adresu za dostavu",
    lastName: "Dodajte prezime u adresu za dostavu",
    company: "Dodajte naziv tvrtke u adresu za dostavu",
    street: "Dodajte ulicu i kućni broj u adresu za dostavu",
    postalCode: "Dodajte poštanski broj u adresu za dostavu",
    city: "Dodajte grad u adresu za dostavu",
    country: "Dodajte državu u adresu za dostavu",
    phone: "Dodajte telefonski broj u adresu za dostavu",
  },
  placeOrder: "Obvezujuća narudžba",
  toOrderDelivery: "Nastavi na adresu dostave",
  toOrderSummary: "Na pregled narudžbe",
  productImg: "Slika proizvoda",
  selectAddressBtn: "Odaberi adresu",
  perPgae: "Stavki po stranici",
  categories: {
    advertising: {
      title: "Reklamni materijali",
      desc: "Sudjelujte izravno ovdje na platformi i osigurajte <br/> 40 dodatnih bodova za klub nagrada.",
    },
    rewards: {
      title: "Ekskluzivne nagrade",
      desc: "Otkrijte bonus ponudu u našem centru za obuku ili na vašoj lokaciji.",
    },
    tools: {
      title: "Alati za radionicu",
      desc: "Iskoristite bodove za obuke trećih strana <br/> i smanjite troškove.",
    },
    trainings: {
      title: "Obuke i tečajevi",
      desc: "Otkrijte bonus ponudu u našem centru za obuku ili na vašoj lokaciji.",
    },
    salesroom: {
      title: "Prodajni prostor",
      desc: "Uredite prodajni prostor i ponudite klijentima ugodan boravak.",
    },
    hunter: {
      title: "Hunter",
      desc: "Zamijenite bodove za atraktivnu opremu radionice Hunter.",
    },
  },
  bestSold: "Najprodavanije",
  seasonal: "Sezonsko",
  affordable: "Skoro gotovo",
  forPoints: "za {points} bodova",
  reachedPoints: "Potrebni bodovi postignuti",
  remainingPoints: "Nedostaje {points} bodova",
  favoriteProducts: {
    description: "Ovdje ćete pronaći spremljene proizvode.",
  },
  categoryPageDescriptionFallback: "Materijal za radionicu ili drugi kvalitetni proizvodi s Bridgestone logotipom za vaše poduzeće",
  variant: "Varijante na izbor",
};
export default {
  messages,
};
